export default __webpack_public_path__ + "static/media/reports.63da7bc9.svg";